import { http } from './http.jsx';

export const roleService = {
  // Get all permissions
  getPermissions: () => http.get('/api/admin/permissions-lite'),
  
  // Get all roles
  getRoles: (params = {}) => http.get('/api/admin/roles', { params }),
  
  // Get single role
  getRole: (roleId) => http.get(`/api/admin/roles/${roleId}`),
  
  // Create new role
  createRole: (data) => http.post('/api/admin/roles', data),
  
  // Update role
  updateRole: (roleId, data) => http.put(`/api/admin/roles/${roleId}`, data),
  
  // Delete role
  deleteRole: (roleId) => http.delete(`/api/admin/roles/${roleId}`),
  
  // Get roles lite (for dropdowns)
  getRolesLite: () => http.get('/api/admin/roles-lite'),
};

